import styled from 'styled-components';

export const DeleteButton = styled.button`
  position: absolute;
  top: 0;
  right: 20px;
  bottom: 0;
  margin: auto;
  background: #3c3c3c;
  color: #777;
  font-size: 12px;
  height: 26px;
  border-radius: 2px;
  padding: 2.5px 8px;
  border: none;
  outline: none;

  &:hover {
    cursor: pointer;
    background: red;
    color: white;
  }
`;
